import { Component, Input } from '@angular/core';
import {Reservation} from '../../api/model/reservation/reservation.model';

@Component({
  selector: 'stay-mgmt-nights-guests',
  templateUrl: './nights-guests.component.html',
  styleUrls: ['./nights-guests.component.scss']
})
export class NightsGuestsComponent{

  @Input() messages;
  private _reservation: Reservation;
  numberOfGuests: number;

  constructor() {}

  get reservation(): Reservation {
    return this._reservation;
  }

  @Input()
  set reservation(reservation: Reservation) {
    if (reservation) {
      this._reservation = reservation;
      this._setNumberOfGuests();
    }
  }

  private _setNumberOfGuests () {
    this.numberOfGuests = this._reservation.stay.numberOfAdults
      + this._reservation.stay.numberOfChildren;
  }
}




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/nights-guests/nights-guests.component.ts